"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Monitor = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#000' : _b, _c = _a.scale, scale = _c === void 0 ? 1 : _c, _d = _a.strokeWidth, strokeWidth = _d === void 0 ? 1 : _d;
    return (react_1.default.createElement("svg", { width: 24 * scale, height: 24 * scale, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M20 3H4C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H20C21.1046 17 22 16.1046 22 15V5C22 3.89543 21.1046 3 20 3Z", stroke: color, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: strokeWidth }),
        react_1.default.createElement("path", { d: "M8 21H16", stroke: color, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: strokeWidth }),
        react_1.default.createElement("path", { d: "M12 17V21", stroke: color, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: strokeWidth })));
};
exports.default = Monitor;
//# sourceMappingURL=Monitor.js.map